import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.09 12.009c-1.33-.865-3.09.09-3.09 1.676v5.67q.007.303.093.571c.38 1.202 1.848 1.812 2.997 1.066l4.33-2.815a1.998 1.998 0 0 0 0-3.354z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M21.898 13.432Q22 12.73 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10h.03a3.9 3.9 0 0 1-.983-2.056A8.001 8.001 0 0 1 12 4a8 8 0 0 1 7.998 8.164l1.512.982q.206.135.388.286"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.59 10.012A5.001 5.001 0 1 0 11 16.9v-3.215c0-2.943 3.027-4.8 5.59-3.673"
    }
  )
);
var SvgRecordingResumeOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RecordingResumeOutlined_default = SvgRecordingResumeOutlined;

export { RecordingResumeOutlined_default as default };
